/**
 * Custom Scroll to Top Handler
 */

(function() {
    let isInitialLoad = true;
    let lastUrl = window.location.href;
    let navigationInProgress = false;
    
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    function scrollToTop() {
      if (isIOS) {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 50);
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }

    function forceScrollToTop() {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
    }

    window.addEventListener('popstate', function(event) {
      navigationInProgress = true;
      
      if (isMobile) {
        setTimeout(() => {
          forceScrollToTop();
          navigationInProgress = false;
        }, 200);
      } else {
        setTimeout(() => {
          scrollToTop();
          navigationInProgress = false;
        }, 100);
      }
    });

    document.addEventListener('visibilitychange', function() {
      if (!document.hidden && !isInitialLoad) {
        setTimeout(() => {
          if (window.location.href !== lastUrl) {
            lastUrl = window.location.href;
            forceScrollToTop();
          }
        }, 100);
      }
    });

    document.addEventListener('DOMContentLoaded', function() {
      document.addEventListener('click', function(event) {
        const link = event.target.closest('a[href]');
        if (link && link.href && !navigationInProgress) {
          try {
            const url = new URL(link.href);
            const currentUrl = new URL(window.location.href);
            
            if (url.origin === currentUrl.origin && 
                url.pathname !== currentUrl.pathname && 
                !url.hash.startsWith('#') && 
                !link.hasAttribute('target') &&
                !link.closest('.pagination') &&
                !event.ctrlKey && !event.metaKey) {
              
              navigationInProgress = true;
              
              sessionStorage.setItem('scrollToTop', 'true');
              
              if (isMobile) {
                setTimeout(() => {
                  forceScrollToTop();
                  navigationInProgress = false;
                }, 300);
              } else {
                setTimeout(() => {
                  scrollToTop();
                  navigationInProgress = false;
                }, 150);
              }
            }
          } catch (e) {
            console.log('URL parsing error:', e);
          }
        }
      });

      document.addEventListener('submit', function(event) {
        const form = event.target;
        if (form && form.action && !form.action.includes('#') && !navigationInProgress) {
          navigationInProgress = true;
          sessionStorage.setItem('scrollToTop', 'true');
          
          setTimeout(() => {
            if (isMobile) {
              forceScrollToTop();
            } else {
              scrollToTop();
            }
            navigationInProgress = false;
          }, isMobile ? 300 : 150);
        }
      });

      const observer = new MutationObserver(function(mutations) {
        if (navigationInProgress) return;
        
        let shouldScroll = false;
        
        mutations.forEach(function(mutation) {
          if (window.location.href !== lastUrl) {
            lastUrl = window.location.href;
            shouldScroll = true;
          }
          
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            for (let node of mutation.addedNodes) {
              if (node.nodeType === Node.ELEMENT_NODE && 
                  (node.matches && node.matches('.main-content, #MainContent, .collection, .product') ||
                    node.querySelector && node.querySelector('.main-content, #MainContent, .collection, .product'))) {
                shouldScroll = true;
                break;
              }
            }
          }
        });
        
        if (shouldScroll && !isInitialLoad) {
          navigationInProgress = true;
          setTimeout(() => {
            if (isMobile) {
              forceScrollToTop();
            } else {
              scrollToTop();
            }
            navigationInProgress = false;
          }, isMobile ? 200 : 100);
        }
      });

      observer.observe(document.head, { childList: true, subtree: true });
      observer.observe(document.body, { childList: true, subtree: true });
      
      const mainContent = document.getElementById('MainContent');
      if (mainContent) {
        observer.observe(mainContent, { childList: true, subtree: true });
      }

      const facetForms = document.querySelectorAll('facet-filters-form form, .facets-container form');
      facetForms.forEach(function(form) {
        form.addEventListener('input', function() {
          if (!navigationInProgress) {
            navigationInProgress = true;
            setTimeout(() => {
              if (!isInitialLoad) {
                if (isMobile) {
                  forceScrollToTop();
                } else {
                  scrollToTop();
                }
              }
              navigationInProgress = false;
            }, isMobile ? 1000 : 800);
          }
        });
      });

      document.addEventListener('click', function(event) {
        if (event.target.matches('.js-facet-remove, .active-facets__button') && !navigationInProgress) {
          navigationInProgress = true;
          setTimeout(() => {
            if (!isInitialLoad) {
              if (isMobile) {
                forceScrollToTop();
              } else {
                scrollToTop();
              }
            }
            navigationInProgress = false;
          }, isMobile ? 700 : 500);
        }
      });
    });

    window.addEventListener('load', function() {
      if (sessionStorage.getItem('scrollToTop') === 'true') {
        sessionStorage.removeItem('scrollToTop');
        if (!window.location.hash) {
          setTimeout(() => {
            forceScrollToTop();
          }, 100);
        }
      }
      
      setTimeout(() => {
        isInitialLoad = false;
      }, 1000);

      if (!window.location.hash && !isInitialLoad) {
        setTimeout(() => {
          if (isMobile) {
            forceScrollToTop();
          } else {
            scrollToTop();
          }
        }, 100);
      }
    });

    if (window.Shopify && window.Shopify.theme) {
      document.addEventListener('shopify:section:load', function() {
        if (!isInitialLoad && !navigationInProgress) {
          setTimeout(() => {
            if (isMobile) {
              forceScrollToTop();
            } else {
              scrollToTop();
            }
          }, 100);
        }
      });
    }

    if (isMobile) {
      window.addEventListener('orientationchange', function() {
        setTimeout(() => {
          if (!isInitialLoad && window.location.href !== lastUrl) {
            forceScrollToTop();
          }
        }, 500);
      });

      window.addEventListener('focus', function() {
        if (!isInitialLoad && !document.hidden) {
          setTimeout(() => {
            if (window.location.href !== lastUrl) {
              lastUrl = window.location.href;
              forceScrollToTop();
            }
          }, 200);
        }
      });
    }

    window.scrollToTopCleanup = function() {
      navigationInProgress = false;
      sessionStorage.removeItem('scrollToTop');
    };

})();